import { Card, Form } from 'antd'
import { useEffect } from 'react'
import { useParams } from 'react-router-dom'

import { useClassifierServiceGetCommonClassifierElementListEndpoint } from 'src/api/queries'
import { useTablePagination } from 'src/hooks'
import { useLocales } from 'src/locales'

import { ElementsTable } from '../ElementsTable'

export const ClassifierElements = () => {
  const { t } = useLocales()
  const { id } = useParams()
  const pagination = useTablePagination()

  const [form] = Form.useForm()

  const queryParams = {
    pageNumber: Number(pagination.current),
    pageSize: Number(pagination.pageSize)
  }

  const { data, isLoading } =
    useClassifierServiceGetCommonClassifierElementListEndpoint({
      id: String(id),
      ...queryParams
    })

  useEffect(() => {
    if (data) form.setFieldValue('elements', data.data)
  }, [data])

  return (
    <Card loading={isLoading} title={t('classifiers.elements')}>
      <Form form={form} layout="vertical" requiredMark={false}>
        <Form.List name="elements">
          {(fields, { add, remove }) => (
            <ElementsTable
              pagination={pagination}
              data={data}
              form={form}
              fields={fields}
              add={add}
              remove={remove}
            />
          )}
        </Form.List>
      </Form>
    </Card>
  )
}
